import { Quaternion } from "./Quaternion.js";
import { Vector3 } from "./Vector3.js";
export const Deg2Rad = Math.PI / 180;
export const Rad2Deg = 180 / Math.PI;
export function circleRemainder(a, period = 2 * Math.PI) {
    if (a >= 0)
        return a % period;
    let first = -(-a % period);
    return first == 0 ? 0 : first + period;
}
export function clamp(x, minValue, maxValue) {
    return Math.min(Math.max(x, minValue), maxValue);
}
export function timestampToJd(t) {
    return t / 86400000 + 2440587.5;
}
export function jdToTimestamp(jd) {
    return Math.round((jd - 2440587.5) * 86400000);
}
export function lonLatDegToDecart(lon, lat) {
    return lonLatRadToDecart(lon * Deg2Rad, lat * Deg2Rad);
}
export function lonLatRadToDecart(lon, lat) {
    const cos_lat = Math.cos(lat);
    return new Vector3(cos_lat * Math.cos(lon), Math.sin(lat), cos_lat * Math.sin(lon));
}
export function longitude(position, planetLocalRotation) {
    const v = Vector3.MultiplyQuaternionByVector3(Quaternion.Inverse(planetLocalRotation), position);
    return Math.atan2(v.z, v.x) * Rad2Deg;
}
export function remainder(a, b) {
    if (a >= 0)
        return a % b;
    const first = -(-a % b);
    return first == 0 ? 0 : first + b;
}
